<div class="overlay">
  <div class="modal" style="width: 100%; height: 100%; ">
    <div class="modal-content">
      <div class="flex justify-content-between flex-wrap" style="
          padding-top: 15px;
          padding-bottom: 16px;
          padding-right: 2px;
          padding-left: 70px;
          border-bottom: 1px solid #f2f4f7;
        ">
        <div class="img">
          <div class="flex justify-content-start flex-wrap">
            <div class="flex align-items-center justify-content-center mr-1">
              <img src="assets/image/auto-e-care-logo.png" alt="Logo" class="svg-black" />
            </div>
            <!-- <div class="flex align-items-center justify-content-center">
              <p style="color: #1d2939; font-weight: 700; font-size: 18px">
                Auto ECare
              </p>
            </div> -->
          </div>
        </div>
        <!-- <div class="flex align-items-center justify-content-center">
          <p style="font-weight: 700; color: #333; font-size: 24px">
            {{
            editMode
            ? "Update Service Advisor Form"
            : "Add Service Advisor Form"
            }}
          </p>
        </div> -->
        <div class="flex justify-content-center flex-wrap align-items-center"> 
          <div class=" cross-icon">
             <i class="pi pi-times" style="cursor: pointer; font-size: 1em; top: 0;" (click)="close()"></i>
           </div>
        </div>   
      </div>

      <!-- Combined Sidebar and Content Section -->
      <div class="flex" style="height: calc(100vh - 70px); ">
        <div class="sidebar" style="margin-top: 62px">
          <ul>
            <li>
              <a (click)="setActiveSection('map-location')" [ngClass]="{
                  active: activeSection === 'map-location'
                }">
                <i class="pi pi-map-marker"></i>Location
              </a>
            </li>
            <li>
              <a (click)="setActiveSection('address-proof')" [ngClass]="{ active: activeSection === 'address-proof' }">
                <i class="pi pi-file-plus"></i>Address-Proof
              </a>
            </li>
            <li>
              <a (click)="setActiveSection('service-advisor-details')" [ngClass]="{
                  active: activeSection === 'service-advisor-details'
                }">
                <i class="pi pi-user"></i>Technical Advisor Details
              </a>
            </li>
            <li>
              <a (click)="setActiveSection('resume')" [ngClass]="{ active: activeSection === 'resume' }">
                <i class="pi pi-cloud-upload"></i>Resume
              </a>
            </li>
            <li>
              <a (click)="setActiveSection('service-advisor-certificates')" [ngClass]="{
                  active: activeSection === 'service-advisor-certificates'
                }">
                <i class="pi pi-list"></i> Upload Certificates
              </a>
            </li>
          </ul>
        </div>

        <!-- Conditional Content Rendering -->
        <div class="content" style="flex-grow: 1;"  [ngClass]="{'no-scroll': activeSection === 'map-location'}">
          <app-map-location *ngIf="activeSection ==='map-location'" (nextSection)="setActiveSection('address-proof')"
            [formStateService]="serviceAdvisorformStateService" [formSource]="'Advisor'"></app-map-location>

          <app-addressproof *ngIf="activeSection === 'address-proof'"
            (nextSection)="setActiveSection('service-advisor-details')"
            [formStateService]="serviceAdvisorformStateService" [formSource]="'Advisor'"></app-addressproof>

          <app-add-service-advisor-details *ngIf="activeSection === 'service-advisor-details'"
            (nextSection)="setActiveSection('resume')" [editMode]="editMode"></app-add-service-advisor-details>

          <app-service-advisor-resume *ngIf="activeSection === 'resume'" [editMode]="editMode"
            (nextSection)="setActiveSection('service-advisor-certificates')"></app-service-advisor-resume>

          <app-service-advisor-certificates *ngIf="activeSection === 'service-advisor-certificates'" (close)="close()"
            (updateList)="onUpdateUserList()"></app-service-advisor-certificates>
        </div>
      </div>
    </div>
  </div>
</div>